import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule, MatDialogModule } from "@angular/material";
import { ConfirmationPopupWithSvgComponent } from "./confirmation-popup-with-svg.component";
import { SkeltonConfirmationPopupWithSvgComponent } from "./skelton-popup-with-svg/skelton-confirmation-popup-with-svg.component";

@NgModule({
    entryComponents: [ConfirmationPopupWithSvgComponent],
    imports: [CommonModule, MatButtonModule, MatDialogModule],
    exports: [ConfirmationPopupWithSvgComponent, SkeltonConfirmationPopupWithSvgComponent],
    declarations: [ConfirmationPopupWithSvgComponent, SkeltonConfirmationPopupWithSvgComponent],
})
export class ConfirmationPopupWithSvgModule {}